import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../../lib/requireAuth.jsx';
import withRouterParams from '../../../lib/withRouterParams.jsx';

import OrgStakeholdersContainer from '../../../containers/organizations/OrgStakeholdersContainer.jsx';

const OrgStakeholders = () => (
  <>
    <Helmet>
      <title>Organization Stakeholders | ChangeSync</title>
    </Helmet>

    <OrgStakeholdersContainer />
  </>
);

export default requireAuth(withRouterParams(OrgStakeholders));
